import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MinifiedServices from "../../../services/Minified.services";
import PersonasPrint from "../../Print/PersonasPrint";
import PersonasAbout from "./PersonasAbout";
import PersonasMarketingApproach from "./PersonasMarketingApproach";
import PersonasOtherInfo from "./PersonasOtherInfo";
import PersonasBasicInfo from "./PersonasBasicInfo";
import { setLoadingPersonasData, setLoadingPersonasImage, setPersonasData, setPersonasImage } from "../../../store/components/Minified.slice";
import { getTrackKeyPersona } from "../../../utils/minified/MinifiedHelper";
import TrackFeatureServices from "../../../services/TrackFeature.services";

const PersonasResult = ({
    forPrint
}) => {
    const dispatch = useDispatch()
    const [showPrintPersonas, setShowPrintPersonas] = useState(false)

    const {
        personasParams,
        personasData,
        personasImage,
        loadingPersonasData,
        loadingPersonasImage
    } = useSelector((state) => state.minified)

    useEffect(() => {
        getPersonaDetails();
    }, [personasParams])

    const classColor = personasParams?.classType || "green";

    const fDownloadPDF = () => {
        setShowPrintPersonas(true)
    };

    const fReloadPersona = () => {
        getPersonaDetails(true)
    };

    const getPersonaDetails = (reLoad) => {
        dispatch(setLoadingPersonasData(true))
        dispatch(setLoadingPersonasImage(true))
        let featureKey = getTrackKeyPersona(personasParams.itemId);
        if (reLoad) {
            featureKey = featureKey.split(personasParams.itemId).join(personasParams.itemId + "ReLoad")
        }
        const { commonParams, getNewRequestResponse } = TrackFeatureServices.getMonitor({ featureKey })

        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor()
        const toMonitorParams = {
            ...commonParams,
            ...getNewRequestResponse(),
        }
        const monitorCallBack = (params, url) => {
            toMonitorParams.url = url
            startMonitor(params, toMonitorParams)
        }
        MinifiedServices.getPersonas(personasParams, personasParams.itemId, reLoad, monitorCallBack).then((resp) => {
            endMonitor(resp, toMonitorParams)
            dispatch(setLoadingPersonasData(false))
            dispatch(setPersonasData(resp === "error" ? resp : resp.data))

            const { startMonitor: imageStartMonitor, endMonitor: imageEndMonitor } = TrackFeatureServices.getMonitor()
            const toMonitorParamsImage = {
                ...commonParams,
                ...getNewRequestResponse(),
            }

            const monitorCallBackImage = (params, url) => {
                toMonitorParamsImage.url = url
                imageStartMonitor(params, toMonitorParamsImage)
            }
            if (resp === "error") {
                imageEndMonitor("error", toMonitorParamsImage)
                dispatch(setLoadingPersonasImage(false))
                dispatch(setPersonasImage("error"))
            } else {
                MinifiedServices.getPersonasImage(resp.data, personasParams.itemId, reLoad, monitorCallBackImage).then((respImage) => {
                    imageEndMonitor(respImage, toMonitorParamsImage)
                    dispatch(setLoadingPersonasImage(false))
                    // dispatch(setPersonasImage("error"))
                    dispatch(setPersonasImage(respImage === "error" ? respImage : respImage.imageUrl || respImage.data))
                })
            }
        })
    }

    return <>
        {!forPrint && <PersonasPrint visible={showPrintPersonas} onClose={setShowPrintPersonas} />}
        <PersonasBasicInfo
            loadingImage={loadingPersonasImage}
            loading={loadingPersonasData}
            classColor={classColor}
            onClickReloadPersona={fReloadPersona}
            onClickDownloadPDF={fDownloadPDF}
            data={personasData}
            image={personasImage}
            targetSize={personasParams.targetSize}
            forPrint={forPrint}
        />
        <PersonasAbout loading={loadingPersonasData} data={personasData?.["Key Message"]} classColor={classColor} />
        {/* {!loadingPersonasData && <PersonasNewFeature classColor={classColor} />} */}

        {/* <Container className="drow gap-2 download-personas" style={styleForDownload}>
            <Container className="minified-result-item dcol flex-2">
                <span className={`personas-title${classColor}`}><GlobalOutlined style={{ marginRight: "2mm" }} /> Geographical Map</span>
            </Container>
            <Container className="minified-result-item dcol flex-1">
                <span className={`personas-title${classColor}`}><TabletOutlined style={{ marginRight: "2mm" }} /> Device Type</span>
            </Container>
        </Container> */}

        <PersonasMarketingApproach
            loading={loadingPersonasData}
            data={personasData?.["Marketing Approach"]}
            classColor={classColor}
            forPrint={forPrint}
        />
        <PersonasOtherInfo
            loading={loadingPersonasData}
            data={personasData}
            classColor={classColor}
            forPrint={forPrint}
        />
    </>
}

export default PersonasResult